
























import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.advertisement) {
        return;
      }
      await this.$store.dispatch("post", [
        this.advertisement["@id"] + "/resume",
        this.advertisement
      ]);
      this.$emit("success");
      cb();
    }
  }
});
